<template>
  <v-slide-y-transition mode="out-in"> 
    <div>
      <v-tabs dark 
        v-model="active"
        v-bind:color="kompetisi ? kompetisi.color : 'black'"
        show-arrows      
      >    
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab v-for="(item, i) in tabs" :key="i">
          {{item.name}}
        </v-tab>            
        <v-tabs-items v-if="kompetisi">
          <v-progress-linear color="info" :indeterminate="true" v-if="loading" height="5" class="ma-0"></v-progress-linear>    
          <v-tab-item
            v-for="(item, i) in tabs"         
            :key="i"
            class="tabs-scroll"
          >
            <v-card flat>
              <v-card-text>
                <v-text-field solo label="Type to search" v-model="tabs[i].areaSearch" clearable hide-details>
                  <v-fade-transition
                    slot="append"
                    leave-absolute
                  >
                    <v-progress-circular
                      v-if="loading"
                      size="18"
                      width="2"
                      :color="kompetisi.color"
                      indeterminate
                    ></v-progress-circular>
                    <v-icon v-else :color="kompetisi.color" @click="setAreas(item, true)">refresh</v-icon>
                  </v-fade-transition>
                </v-text-field>
                <v-container grid-list-md fluid pa-0 mt-3>
                  <v-layout row wrap>
                    <v-flex lg4 sm6 xs12 v-for="(data) in tabs[i].area.data" v-if="data.is_author">
                      <!--<router-link v-if="data.tingkat==5" target="_blank" v-bind:to="{path:'/hitung/form', query: {
                          kompetisi_id : $route.query.kompetisi_id,
                          mode : kompetisi.mode,
                          tps_id : data.id, 
                      }}">-->
                        <v-card v-if="data.tingkat==5" class="cursor" @click="showDialog($route.query.kompetisi_id, data.id, kompetisi.mode)">
                          <v-card-text>
                            <div class="layout row ma-0 align-center justify-space-between">
                              <div class="text-box">
                                <div class="caption pb-2">{{data.name}}</div>                              
                                <!--<span class="grey--text">{{data.contain.done}} <v-icon small color="green">trending_up</v-icon> {{data.contain.all}} TPS</span>-->
                              </div>
                              <div class="chart">
                                <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value="persenContain(data.contain)"
                                    :color="quickcountMode? 'warning':'success'"
                                  >                                  
                                    <span v-if="persenContain(data.contain)==100">
                                        <v-icon color="success" v-if="!quickcountMode">check_circle</v-icon>
                                        <v-icon color="warning" v-else>fast_forward</v-icon>
                                    </span>
                                    <v-icon v-else>history</v-icon>
                                  </v-progress-circular>
                                  {{data.sah}}
                              </div>
                            </div>                            
                          </v-card-text>
                        </v-card>             
                      <!--</router-link>-->
                      <v-card class="cursor" v-else @click="newTab(data,i+1)">
                        <v-card-text>
                          <div class="layout row ma-0 align-center justify-space-between">
                            <div class="text-box">
                              <div class="caption pb-2">{{data.name}}</div>
                              <span class="grey--text">{{quickcountMode ? data.contain.quick : data.contain.done}} <v-icon small color="green">trending_up</v-icon> {{data.contain.all}} TPS</span>                            
                            </div>
                            <div class="chart">
                              <v-progress-circular
                                :size="60"
                                :width="5"
                                :rotate="360"
                                :value="persenContain(data.contain)"
                                :color="quickcountMode?(data.contain.quick>0?'warning':'grey'):(data.contain.done>0?'success':'grey')"
                              >
                              {{persenContain(data.contain)}}%
                              </v-progress-circular>
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>             
                    </v-flex>
                    <v-flex lg4 sm6 xs12 v-if="tabs[i].area.data.length < tabs[i].area.count">
                      <v-btn block class="my-0" color="info" :loading="loading" small dark @click="setAreas(tabs[i])">load more ...</v-btn>
                    </v-flex>  
                  </v-layout> 
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>      
      <form-dialog :dialog="dialog" :cekup="cekup" v-on:closeDialog="closeDialog($event)"></form-dialog>
    </div>  
  </v-slide-y-transition>
</template>

<script>  
import Model from '@/apps/frc/models/Hitung';  
import FormDialog from './dialog';
const  model = new Model();

export default {    
    components:{FormDialog},
    $_veeValidate: {
      validator: 'new'
    },    
    props:{    
      quickcountMode : {
        type: Boolean,
        default: false,
      },    
    },  
    data: () => ({
      tabs : [
          {name:null, area_ids:[], tingkat_ids:[],areaSearch:null, area:{data:[],count:0,page:1}},
      ],
      active : 0,
      search : [], 
      kompetisi_id : null,
      kompetisi : null,                      
      formPath : '/kompetisi/form',      
      loading  : true,
      pagination: {},
      complex  : {
          selected: [],
          headers: [              
            { text: 'Kompetisi', value: 'name', align:'center', sortable:false}
          ],
          items: []
      },
      dialog : false,
      cekup  : {
        kompetisi_id : null,
        tps_id : null,
        mode : null,
      }  
    }),  
    asyncComputed:{
        startKompetisi(){           
            if(this.kompetisi_id != this.$route.query.kompetisi_id){               
              this.loading = true;            
              this.kompetisi_id = this.$route.query.kompetisi_id;
              return model.kompetisi({id:this.$route.query.kompetisi_id}).then(res=>{
                  if(res.status !== 200) return;
                  let index = 0;                 
                  this.kompetisi = res.data;
                  this.newTab(res.data,index);
                  
                  if(this.$route.query.area_ids){                    
                      let a_ids = this.$route.query.area_ids;
                      let t_ids = this.$route.query.tingkat_ids;                      
                      let area_ids    = Array.isArray(a_ids) ? a_ids : [a_ids];
                      let tingkat_ids = Array.isArray(t_ids) ? t_ids : [t_ids];
                      
                      let arr = this.urutkan(tingkat_ids, area_ids);                      
                      this.setTabs(arr);                                           
                  }
                  return res.data; 
              });
            } else {
              
              if(this.$route.query.area_ids){
                let a_ids = this.$route.query.area_ids;
                let area_ids    = Array.isArray(a_ids) ? a_ids : [a_ids];
                if((this.tabs.length-1) > area_ids.length){                    
                  this.active = (area_ids.length);                       
                  this.dialog = false;
                } 
              } else {
                this.active = 0;
              }
              return ;//this.kompetisi;
            }
        }
    },
    watch:{
    },
    mounted(){  },        
    created () {
        if( model.vuex ){
            var context = this;        
            context.$store.watch(
                function (state) { return state },
                function () { model.all().then(data => { context.complex.items = data }) },{ deep: true }
            );                                     
        }
    },
    methods: {    
        closeDialog(e){
          this.dialog = e.dialog;
          this.cekup  = e.cekup;   
          if(e.reload){            
            let fm = this.tabs[this.tabs.length-1];
            this.setAreas(fm ,true);
          }
        },
      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},               
                     
        firstLetter (name) {
            return name.charAt(0);
        },
        
        persenContain(contain){
            return this.quickcountMode ? (contain.quick/contain.all*100).toFixed(1) :(contain.done/contain.all*100).toFixed(1);
        },
        
        setAreas(fm, reset = false){            
            this.loading = true;    
            if(!fm) return;
            if(reset) fm.area.page = 1;
            model.areas({tingkat: (parseInt(fm.tingkat) + 1), kompetisi_id:this.kompetisi_id,'AreaSearch[parent_id]':fm.area_id, page:fm.area.page, 'AreaSearch[name]':fm.areaSearch}).then(resp=>{
                if(reset) {fm.area.data = []; fm.area.page = 1;}                
                fm.area.data    = [...fm.area.data, ...resp.data.data];                
                fm.area.page++;
                fm.area.count = resp.data.count;   
                if(reset && fm.area.data.length == 0) {fm.area.page = 1;}
                this.loading = false;
            });
        },
        
        async setTabs(arr){
            var index = 1;
            for(var i in arr){
                let res = await model.areas({tingkat:arr[i].a,'AreaSearch[id]':arr[i].b,kompetisi_id:this.kompetisi_id});
                this.newTab(res.data.data[0], index++);                
            }
        },
        
        newTab(data, i){
            if(data.tingkat < 5){                          
                for(let j=this.tabs.length; j >= i ; j--){
                    this.tabs.splice(j, 1);
                }
                if(!this.tabs[i]){
                    this.tabs.push({name:data.name, area_ids:[], tingkat_ids:[],areaSearch:null, area:{data:[], count:0, page:1}});             
                }
                Object.assign(this.tabs[i], data);
                this.$watch(['tabs',i,'areaSearch'].join('.'), (val)=>{
                  const ctx = this; setTimeout(function(){
                    if(ctx.tabs[i] && val === ctx.tabs[i].areaSearch){
                       ctx.setAreas(ctx.tabs[i], true); 
                    }
                  }, 700);                   
                });
                this.setAreas(this.tabs[i], true);
                this.active = i;   
                if(i > 0){
                    var area_ids = []; var tingkat_ids = []; 
                    for(let j=1; j<this.tabs.length; j++){
                        area_ids.push(this.tabs[j].area_id);
                        tingkat_ids.push(this.tabs[j].tingkat);
                    }
                    this.hitungRoute(area_ids, tingkat_ids); 
                }
            } else {
                this.formRoute(data.id);                
            }
        },
        
        areaRoute (id, tingkat) {
            this.$router.push({path:'/hitung', query: {kompetisi_id: id, tingkat: tingkat}});
        },                
        
        formRoute(tps_id){
            let q = this.$route.query;
            this.$router.push({path:'/hitung/form', query: {
                kompetisi_id : q.kompetisi_id,
                mode : this.kompetisi.mode,
                tps_id : tps_id, 
            }});
        },
        
        hitungRoute(area_ids, tingkat_ids){
            let q = this.$route.query;
            this.$router.push({path:'/hitung', query: {
                kompetisi_id : q.kompetisi_id,
                tingkat : q.tingkat,
                area_ids : area_ids,
                tingkat_ids : tingkat_ids,                
            }});
        },
        
        showDialog(kompetisi_id, tps_id, mode){                        
            Object.assign(this.cekup, {kompetisi_id : kompetisi_id, tps_id:tps_id, mode:mode});
            this.dialog = true;
        },
        
        urutkan(arrA, arrB){
            for(var i=0; i<arrA.length; i++){
              for(var j=i+1; j<arrA.length; j++){
                if(arrA[i]>arrA[j]){
                    var tmpA=arrA[i]; var tmpB=arrB[i]; 
                    arrA[i]=arrA[j];  arrB[i]=arrB[j];
                    arrA[j]=tmpA;     arrB[j]=tmpB;
                }     
              }   
            }
            var result = [];
            for(var i=0; i<arrA.length; i++){
              result.push({a:arrA[i], b:arrB[i]});
            }            
            return result;            
        }
    }
}
</script>
  
